<template>
  <div class="home">
    <br/>
    <img alt="Relia Log" src="../assets/image/ReLIA_logo.png" width="452" height="175.3"/>
    <br/>
    <br/>
    <!-- <p>您可以登录后查看各类仪器存储在服务器上的信息</p> -->
    <Login />
    <br/>
    <div class="footer">
      
      <p>
        <img src="../assets/image/logo01.png" width="20" style="vertical-align: middle; padding-left: -4px;" />
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32120502010362" rel="noreferrer" target="_blank" style="color: inherit; text-decoration: none;">苏公网安备32120502010362号</a>
      </p>

      <a href="https://beian.miit.gov.cn/" target="_blank" style="color: inherit; text-decoration: none;">苏ICP备2025164560号</a>
    </div>
  </div>
</template>

<script>
import Login from '../components/Login.vue';

// Home 组件中直接引入 Login 组件
export default {
  name: 'Home',
  components: {
    Login
  }
}
</script>

<style scoped>
.home {
  text-align: center;
  margin-top: 50px;
  position: relative;
  min-height: 100vh;
}

.footer {
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
  text-align: center;
}
</style>